import axios from "axios";
// import { fetchPost } from "./api";
import { parseJwt } from "./functions";
import { fetchPost } from "./api";
import { redirectToUniversity } from "./redirections";

/**
 * Fonction qui permet de renvoyer un nouveau token
 * @returns {String| null} - Le nouveau token
 */
const regenerateTokens = async () => {
  // On envoie le refresh token au serveur pour qu'il nous renvoie un nouveau token
  let response = await fetchPost("/token/refresh", "{}");
  // On vérifie que la réponse contient un token
  if (!response.token) return null;

  // On renvoie le nouveau toke
  return response.token;
};

/**
 * Fonction qui permet de vérifier si le token est encore valide (si no,, on renvoie le token et le refresh token, si oui on renvoie null)
 * @returns {String} | null} - Le nouveau token
 */
export const processToken = async (userToken) => {
  if (!userToken) return null;
  // On décode le token pour récupérer ses infos (date d'expiration)
  if (!checkTokenValidity(userToken)) return await regenerateTokens();
  else return null;
};

export async function fetchUser(token) {
  const ERR_MSG = "User not found or wrong Authorizations";

  // On récupère les infos de l'user
  let url = process.env.REACT_APP_BASE_URL_API + "/user/connected";
  url = new URL(url);
  let response = await axios.get(url, {
    headers: {
      accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  // On vérifie que l'user existe bien
  if (!response || !response.data) throw Error(ERR_MSG);
  // On renvoie l'user
  return response.data;
}

/**
 * Fonction qui vérifie si un token est encore valide grâce à sa date d'expiration
 * @param {String} userToken - Le token d'authentification
 * @returns {Boolean} - true si le token est n'est pas valide, false sinon
 */
export const checkTokenValidity = (userToken) => {
  let decodedToken = parseJwt(userToken);
  if (!decodedToken || !decodedToken?.exp) return false;

  // On récupère la date d'expiration du token en millisecondes
  let exp = decodedToken.exp * 1000;
  // On récupère la date actuelle en millisecondes
  let now = Date.now();

  //? Si le token a encore une durée de vie d'au moins 40 secondes, on le considère comme valide
  return exp - now > 40000;
};

/**
 * Fonction qui permet d'authentifier un utilisateur en fonction de l'environnement
 * dans lequel il se trouve (dev, prod)
 *
 * - En prod: on redirige l'utilisateur vers le site de son université
 * - En dev: on exécute la fonction par défaut fournie en paramètre
 *
 * @param {Object} university - L'objet université
 * @param {Boolean} isLogin - true si l'utilisateur veut se connecter, false pour s'inscrire
 * @param {Function} defaultAction - La fonction par défaut à exécuter
 * @param {Boolean} isAlumni - true si on est sur le site alumni, false sinon
 */
export const authenticateUser = (
  university,
  isLogin,
  defaultAction,
  isAlumni = false
) => {
  const isProd = process.env.REACT_APP_ENV === "production";
  if (isProd && university.slug !== "uspn") {
    redirectToUniversity(university, isLogin, defaultAction, isAlumni);
  } else {
    defaultAction();
  }
};
